import React, { useState } from "react";
import { useSelector } from "react-redux";
import { LOGGEDIN } from "../../constants/auth";
import { GRID } from "../collections/CollectionsContainer";
import ProductCard from "../common/ProductCard";
import ListCards from "./ListCards";
import ProductListingHeader from "./ProductListingHeader";

const ProductsListing = ({ products, sortBy, setSortBy }) => {
  const [activeView, setActiveView] = useState(GRID);
  const { authState } = useSelector((state) => state.auth);

  return (
    <div className="max-w-full lg:max-w-[80%] w-full md:pl-5 pb-[10px] md:pb-5 grow shrink-0 box-border">
      <ProductListingHeader
        length={products?.length}
        activeView={activeView}
        setActiveView={setActiveView}
      />
      <div className="w-full border-inherit">
        {activeView === GRID ? (
          <div className="w-full border-inherit">
            <div className="grid grid-cols-2 md:grid-cols-3 flex-wrap mb-5 gap-y-4 gap-x-5 border-inherit">
              {products.map(
                (product, index) =>
                  product.media?.length > 0 && (
                    <ProductCard
                      key={index}
                      product={product}
                      showOnSale={String(product.tags).includes("On Sale")}
                    />
                  )
              )}
            </div>
          </div>
        ) : (
          <div className="w-full border-inherit">
            <div className="grid grid-cols-1 flex-wrap mb-5 ml-[-5px] 2xl:ml-[-10px] border-inherit">
              {products.map(
                (product, index) =>
                  product.media.length > 0 && (
                    <ListCards
                      key={index}
                      product={product}
                      isAuthenticated={authState === LOGGEDIN}
                    />
                  )
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductsListing;
